/**
 * useNotification Hook
 * Provides notification management functionality
 */

import { useContext } from 'react';

import { NotificationContext } from '../contexts/NotificationContext';

/**
 * Hook to access notification functionality
 * Must be used within NotificationProvider
 */
export const useNotification = () => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }

  return context;
};

export default useNotification;
